import React from 'react';
import PropTypes from 'prop-types';

import ValidatingField from './validating_field';

class TextField extends ValidatingField {
  constructor(props) {
    super(props);

    this.fieldType = 'text';
  }

  renderInput() {
    return (
      <input
        type={ this.fieldType }
        name={ this.props.name }
        placeholder={ this.props.displayName }
        onChange={ this.handleChange }
        onBlur={ this.handleBlur }
        value={ this.state.value }
        className={ this.state.shouldDisplayError ? 'errored-field' : '' }
        disabled={ this.props.disabled }
      />
    );
  }
}

TextField.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default TextField;
